var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 7 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 5.734c0-.84.668-1.703 1.773-2.109l.125-1.816C1.316 1.477.855 1.113.652.855A.7.7 0 0 1 .492.45C.492.191.692 0 .984 0h4.2c.293 0 .492.191.492.45a.7.7 0 0 1-.16.405c-.203.258-.664.622-1.246.954l.128 1.816c1.102.406 1.77 1.27 1.77 2.11 0 .35-.238.585-.61.585h-2.09v1.848c0 .55-.277 1.105-.382 1.105-.11 0-.387-.554-.387-1.105V6.32H.61C.24 6.32 0 6.086 0 5.734"
  })));
};
export default SvgPin;